import { render, staticRenderFns } from "./BlueButton.vue?vue&type=template&id=0089f7c0"
import script from "./BlueButton.vue?vue&type=script&lang=js"
export * from "./BlueButton.vue?vue&type=script&lang=js"
import style0 from "./BlueButton.vue?vue&type=style&index=0&id=0089f7c0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports